import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

export const useUsers = (currentUser, authLoading) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchUsers = useCallback(async () => {
    if (authLoading || currentUser?.type !== 'admin') return;
    setLoading(true);
    try {
      const res = await axios.get('/api/users');
      setUsers(res.data);
    } catch (err) {
      console.error('Error fetching users:', err);
    } finally {
      setLoading(false);
    }
  }, [currentUser?.type, authLoading]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const addUser = async (formData) => {
    try {
      await axios.post('/api/users', formData);
      fetchUsers();
      alert('User added successfully');
      return true;
    } catch (err) {
      alert(err.response?.data?.msg || 'Error adding user');
      return false;
    }
  };

  return {
    users,
    loading,
    addUser,
    fetchUsers
  };
};
